// export const TICKET_COUNT = 10000
export const TICKET_COUNT = process.env.NODE_ENV !== "production" ? 3000 : 3000;

export const INCOME = 100;

export const TICKET_ADDRESS = "16htvcBNSEA7fZhAdLJphDwQRQJaHpyHTp";

export const USER_TYPE = ["社区节点身份", "超级节点身份"];
